import { FC, memo } from "react"
import { EquipmentSlotCell } from "@/ui/PaperDoll/ui"
import styles from "./PaperDoll.module.scss"
import { IPaperDoll } from "./types"

const PaperDollComponent: FC<IPaperDoll> = ({
  layout,
  itemsByPosition,
  onSlotClick
}) => (
  <div className={styles.PaperDoll}>
    {layout.map((position) => (
      <EquipmentSlotCell
        key={position}
        item={itemsByPosition[position] ?? null}
        position={position}
        onClick={onSlotClick}
      />
    ))}
  </div>
)

export const PaperDoll = memo(PaperDollComponent)
